import { render, staticRenderFns } from "./TransactionChart.vue?vue&type=template&id=98646b50&scoped=true"
import script from "./TransactionChart.vue?vue&type=script&lang=js"
export * from "./TransactionChart.vue?vue&type=script&lang=js"
import style0 from "./TransactionChart.vue?vue&type=style&index=0&id=98646b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98646b50",
  null
  
)

export default component.exports